/**
 * Decoupled map-command contract. Plugin panels live in their own packages and
 * cannot import the host app's map store, so they dispatch a typed window event
 * the host listens for. Keeps plugins and the host loosely coupled.
 */

/** Window CustomEvent name a plugin panel dispatches to fly the host map. */
export const MAP_FLYTO_EVENT = 'vtak:flyto';

/** Detail payload carried by {@link MAP_FLYTO_EVENT}. */
export interface MapFlyToDetail {
  lat: number;
  lon: number;
  zoom?: number;
}

/** Dispatch a map fly-to request from a plugin panel. No-op outside a browser. */
export function emitMapFlyTo(detail: MapFlyToDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<MapFlyToDetail>(MAP_FLYTO_EVENT, { detail }));
}
